<template>
  <div v-if="loaded" class="row">
    <!-- Réorganise ton formulaire ici -->
    <mh-input mhClass="col-12" field="montant" :table="payment" append="€"></mh-input>
    <mh-input mhClass="col-12" field="date" :table="payment"></mh-input>
    <mh-input mhClass="col-12" field="type" :table="payment"></mh-input>
    <mh-input mhClass="col-12" field="commissionUsed" :table="payment" append="%"></mh-input>
    <mh-input
      mhClass="col-12"
      field="compte_debiteur"
      :table="payment"
    ></mh-input>
    <mh-input
      mhClass="col-12"
      field="compte_societeID"
      :table="payment"
      @change="changeCompte()"
    ></mh-input>
    <mh-input
      mhClass="col-12"
      field="numero_extrait"
      :table="payment"
    ></mh-input>
  
    <mh-input readonly mhClass="col-12" field="reception" :table="payment"></mh-input>
    <mh-input mhClass="col-12" field="negotiateurID" :table="payment"></mh-input>

    <b-col class="text-right mt-3">
      <b-button @click="$emit('close')">Annuler</b-button>
      <b-button @click="save" class="ml-3">Enregistrer</b-button>
    </b-col>
  </div>
</template>

<script>
import payments from "@/services/payments";
import MhInput from "@/components/MhInput.vue";
export default {
  name: "WarrantPayment",
  components: {
    MhInput,
  },
  props: {
    payment_id: [Number, String],
    warrant_id: [Number, String],
  },
  data() {
    return {
      payment: {},
      loaded: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      payments
        .payment({
          warrant_id: this.warrant_id,
          payment_id: this.payment_id,
        })
        .then((response) => {
          this.payment = response.data;
          this.loaded = true;
          this.changeCompte();
        });
    },
changeCompte() {
      if (this.payment.compte_societeID.value == 7) {
        this.payment.reception.value = "creancier";
      } else {
        this.payment.reception.value = "societe";
      }
    },
    save() {
      payments
        .update_payment({
          warrant_id: this.warrant_id,
          payment_id: this.payment_id,
          payment: this.payment,
        })
        .then((response) => {
          if (response.data.success) {
            this.$bvToast.toast("payment mise à jour", {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "success",
              autoHideDelay: 2000,
              solid: false,
            });
            for (let el in this.payment) {
              if (this.payment[el]) {
                this.payment[el].error = false;
              }
            }
            this.$emit("change");
            this.$emit("close");
          } else if (response.data.fail) {
            for (let el in this.payment) {
              if (this.payment[el]) {
                this.payment[el].error = false;
              }
            }
            response.data.fail.forEach((element) => {
              this.payment[element.field].error = element.errors.join(" ; ");
            });
          } else if (response.data.error) {
            this.$bvToast.toast("Erreur : " + response.data.error, {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "danger",
              autoHideDelay: 2000,
              solid: false,
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>